import React, { useState, useRef, useMemo, useCallback, useEffect } from 'react';
import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const Box = styled.input`
  margin: 0 7rem;

  aspect-ratio: 2/3;
  width: 40rem;
  height: auto;

  text-align: center;
  background: #fff2;
  border-radius: 5rem;

  outline: none;
  border: 3rem solid #fff0;

  font-size: 24rem;
  font-family: 'Dancing Script', cursive;
  font-weight: bold;
  color: white;

  transition: 0.2s border-color;

  &:focus {
    border-color: #f9ecc2;
  }
`;

const BoxInputs = ({ number, type, onComplete, onIncomplete }: {
  number: number,
  type: "alphabet" | "numeric" | "alphanumeric",
  onComplete: (value: string) => void,
  onIncomplete?: () => void
}) => {
  /**
   * Hooks
   */
  const refs = useRef<HTMLInputElement[]>(Array(number));
  const range = useMemo(() => Array.from(Array(number).keys()), [number]);
  const [input, setInput] = useState<string[]>(() => range.map(() => ""));

  const regex = useMemo(() => {
    switch (type) {
      case "alphabet": return /^[a-zA-Z]+$/;
      case "numeric": return /^[0-9]+$/;
      case "alphanumeric": return /^[a-zA-Z0-9]+$/;
    }
  }, [type]);

  useEffect(() => {
    refs.current.length = number + 1;
  }, [number]);

  /**
   * Not hook
   */
  const getNewValue = useCallback((oldValue: string, doubleValue: string) => {
    const index = doubleValue.indexOf(oldValue);
    return index === 1 ? doubleValue[0] : doubleValue[1];
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const value = e.currentTarget.value;

    if (value === "") {
      //Its a backspace (only works if there are values in the box)
      const clone = [...input];
      clone[index] = value;

      setInput(clone);

      index - 1 >= 0 && refs.current[index - 1].focus();
    }
    else if (regex.test(value)) {
      let _value = value;
      if (value.length !== 1) _value = getNewValue(input[index], value);

      const clone = [...input];
      clone[index] = _value;

      setInput(clone);

      index + 1 >= number ?
        refs.current[index].blur() :
        refs.current[index + 1].focus();

      clone.indexOf("") === -1 ?
        onComplete(clone.join("")) :
        onIncomplete && onIncomplete();
    }
  };

  /**
   * Render
   */
  return (
    <Wrapper>
      {range.map((_, i) =>
        <Box
          tabIndex={i}
          ref={dom => { if (dom) refs.current[i] = dom }}
          key={i}
          size={1}
          maxLength={2}
          value={input[i]}
          onChange={e => handleChange(e, i)}
        />
      )}
    </Wrapper>
  );
}

export default BoxInputs;